
export class GetWebLinkInfoRequestModel {
  // 受注コード
  public orderCode: string = <string>'';

  // Ｐコード
  public pCode: string = <string>'';
}
